<mat-form-field>
    <mat-label>Venue wechseln</mat-label>
    <mat-select [(ngModel)]="currentLocation" (selectionChange)="triggerLocationChange()">
        <mat-option *ngFor="let l of myLocations;let i = index;" [value]="l" (Click)="currentLocationIndex = i">
            {{ l.name }}
        </mat-option>
    </mat-select>
</mat-form-field>